import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ManagementNavbar.css";
import logo from "../assets/image.png"; // Ruta al logo

const ManagementNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Aquí manejarás el cierre de sesión
    console.log("Cerrar sesión");
    navigate("/login");
  };

  return (
    <header className="management-header">
      <Navbar expand="lg" className="management-navbar">
        <Container>
          {/* Logo y título */}
          <div className="management-logo-container" style={{ cursor: "pointer" }}>
            <img src={logo} alt="Deluxe Labs Logo" className="management-logo-img" />
            <span className="management-brand-name">
              Deluxe Labs <span className="management-admin-label">Admin</span>
            </span>
          </div>
          {/* Botón de menú */}
          <Navbar.Toggle aria-controls="navbar-management-nav" />
          <Navbar.Collapse id="navbar-management-nav">
            <Nav className="mx-auto">
              <Nav.Link onClick={() => navigate("/dashboard")}>Dashboard</Nav.Link>
              <Nav.Link onClick={() => navigate("/productos")}>Gestión de Productos</Nav.Link>
              <Nav.Link onClick={() => navigate("/categorias")}>Gestión de Categorías</Nav.Link>
              <Nav.Link onClick={() => navigate("/paginas")}>Gestión de Página</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          {/* Bienvenida y botón de cerrar sesión */}
          <div className="management-user-wrapper">
            <span className="management-welcome-message">Bienvenido, Benjamin Casal</span>
            <button className="management-logout-btn" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </Container>
      </Navbar>
    </header>
  );
};

export default ManagementNavbar;
